import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import delinkUserDetails from './add';

const DelinkDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.delink}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.delink].userPhone]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/userPhone`}
				component={delinkUserDetails}
				exact
			/>
			<Redirect to={`${path}/userPhone`} />
		</Switch>
	);
};

export default DelinkDashboard;
